import React from 'react';
import { Layout } from './src/components/layout';
import { HomeProductProvider } from './src/components/homeProductContext';

// Pass all props (hence the ...props) to the layout component so it has access to things like pageContext or location
const wrapPageElement = ({ element, props }) => {
    const layout = <Layout {...props}>{element}</Layout>;
    return process.env.BRAND === 'bt' ? <HomeProductProvider>{layout}</HomeProductProvider> : layout;
};

export default wrapPageElement;
